module.exports = __webpack_public_path__ + "img/negative.1fd3379c.svg";